<template>
    <div class="userPartner-report_notCloseTable Owning notclose-order-page">
        <div class="header"
            v-if="detailsIsMaster"
        >
          <el-date-picker
            v-if="!realMobile"
            class="input-box header-sub-item date-picker-el"
            size="small"
            v-model="query.pickerTime"
            type="daterange"
            align="left"
            unlink-panels
            value-format="yyyy-MM-dd HH-mm-ss"
            :range-separator="phFileter('root.dateTo')"
            :start-placeholder="phFileter('root.startDate')"
            :end-placeholder="phFileter('root.endDate')"
          >
          </el-date-picker>
          <select-date-duration
            class="header-sub-item"
            v-model="query.pickerTime"
          ></select-date-duration>

          <el-select
            size="small"
            class="order-status input-box header-sub-item select-option-el"
            v-model="tradeType"
            :placeholder="phFileter('User.reportCmd')"
            clearable
          >
            <el-option
              v-for="(item,index) in classTypeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select
            v-if="needOrderSource"
            size="small"
            class="Recharge input-box header-sub-item select-option-el"
            v-model="orderSource"
            :placeholder="phFileter($t('orderSource'))"
            clearable
          >
            <el-option
              v-for="item in orderSourceList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button
            class="btn-box"
            size="small"
            type="primary"
            @click="queryHandle"
          >{{$t('root.search')}}
          </el-button>
          <el-button
            class="btn-box"
            size="small"
            @click="exportHandle"
          >{{$t('root.export')}}
          </el-button>
          <el-button
            class="btn-box"
            size="small"
            @click="clearHandle"
          >{{$t('withgold.clearEmipt')}}
          </el-button>
        </div>
<!--      todo 挂单需要修改字段,以及删掉部分字段-->
        <el-table
                :data="listData"
                v-loading="loading"
                :empty-text="$t('root.noData')"
                @sort-change="sortChange"
                :header-cell-style="{ background: '#F3F2F7',color: '#5E5873' }"
        >
            <div class="table-nodata" slot="empty">
                {{$t('root.noData')}}
            </div>
            <el-table-column
                    :label="$t('User.reportOrderId')"
                    prop="order"
            >
            </el-table-column>
            <el-table-column
                    :label="$t('User.reportSymbol')"
                    prop="symbol"
                    sortable
            >
            </el-table-column>
            <el-table-column
                    :label="$t('User.reportCmd')"
                    min-width="110px"
            >
                <template slot-scope="scope">
                    <span>{{scope.row.cmd  % 2 == 0 ? phFileter('User.buy') : phFileter('User.sell')}}</span>
                    <el-tooltip class="item" effect="dark" :content="`${$t('signal_source')}: ${scope.row.masterAlias}`" placement="top">
                        <span
                                v-if="scope.row.reason === 0"
                                class="copy-tag">{{'COPY'}}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column
                    :label="$t('Home.forexVolume')"
                    prop="volume"
                    min-width="130px"
                    sortable
            />
            <el-table-column
                    :label="$t('pending_order') + '/' + $t('User.reportCloseTime')"
                    min-width="160px"
                    prop="openTime"
                    sortable
            >
                <template slot-scope="scope">
                    <div>{{parseTime(scope.row.openTime)}}</div>
                    <div>-</div>
                </template>
            </el-table-column>
            <el-table-column
                    :label="$t('pending_order') + '/' + $t('Price')"
                    min-width="160px"
                    prop="openPrice"
                    sortable
            >
                <template slot-scope="scope">
                    <div>{{scope.row.openPrice}}</div>
                </template>
            </el-table-column>
            <el-table-column
                    :label="$t('User.reportTp') + '/' + $t('User.reportSl')"
                    min-width="160px"
            >
                <template slot-scope="scope">
                    <div>{{scope.row.tp || '-'}}</div>
                    <div>{{scope.row.sl || '-'}}</div>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">{{$t('total')}} {{total}} {{$t('item')}}</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { limitNumber } from '@/utils/validate';
  import { parseTime } from '@/utils/index';
  import initData from '@/mixins/initData';
  import { getCustType } from '@/utils/common';
  import { export_json_to_excel, formatJson } from '@/vendor/Export2Excel';
  import request from '@/utils/ajax';

  export default {
    name: 'order_pending',
    props: {
      dateTime: {
        type: Object,
      },
      needOrderSource: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        classTypeList: [
          {
            value: 0,
            label: this.$t('User.buy')
          }, {
            value: 1,
            label: this.$t('User.sell')
          }
        ],
        tradeType: '',
        accountTypeList: [
          {
            label: this.$t('Myself'),
            value: 1
          },
          {
            label: this.$t('All_subordinates'),
            value: 0
          },
          {
            label: `${this.$t('Myself')} + ${this.$t('All_subordinates')}`,
            value: 0
          }
        ],
        statistics: {
          volumeSum: '',
          profitSum: ''
        },
        orderSource: '',
        orderSourceList:[
          {
            label: this.$t('Documentary_transactions'),
            value: 0,
          },
          {
            label: this.$t('autonomous_transaction'),
            value: 1,
          },
        ],
      };
    },
    mixins: [initData],
    computed: {
      ...mapGetters(['userInfo','detailsIsMaster','realMobile']),
    },
    mounted() {
      this.$nextTick(() => {
        this.init();
      });
    },
    methods: {
      parseTime,
      getCustType,
      beforeInit() {
        this.url = '/crm/reception/queryOrders';
        this.params = {
          page: this.page - 1,
          size: this.size,
          orderType: 2,
          mtId: this.$route.params.mtid,
        };
        if (this.query.pickerTime) {
          this.params.startTime = this.query.pickerTime[0];
          this.params.endTime = this.query.pickerTime[1];
        }
        if(this.tradeType !== ''){
          this.params.cmd = this.tradeType;
        }
        if(this.needOrderSource){
          this.params.reason = this.orderSource;
        }
        if(this.sort){
          this.params.sort = this.sort;
        }
        if(this.dateTime){
          this.params.beginDate = parseTime(this.dateTime.beginDate);
          this.params.endDate = parseTime(this.dateTime.endDate);
        }
        return true;
      },
      phFileter(data) {
        return this.$t(data);
      },
      loginInputHandle() {
        return this.query.login = limitNumber(this.query.login);
      },
      //  清空
      clearHandle() {
        this.tradeType = '';
        this.orderSource = '';
        this.query.pickerTime = '';
      },
      queryHandle() {
        this.page = 1;
        this.init();
      },
      exportHandle() {
        let _this = this;
        let params = {
          export: 1,
          orderType: 1,
          mtId: +this.$route.params.mtid,
        };
        if (this.query.pickerTime) {
          params.startTime = this.query.pickerTime[0];
          params.endTime = this.query.pickerTime[1];
        }
        if(this.tradeType !== ''){
          params.cmd = this.tradeType;
        }
        if(this.needOrderSource){
          params.reason = this.orderSource;
        }
        if(this.sort){
          params.sort = this.sort;
        }
        if(this.dateTime){
          params.beginDate = parseTime(this.dateTime.beginDate);
          params.endDate = parseTime(this.dateTime.endDate);
        }
        request({
          url: this.url,
          method: 'get',
          params: params,
          addToken: true
        }).then((res) => {
          if (!res.data.content.length) return;
          const tHeader = ['订单号(Order)', '品种(Symbol)', '交易类型(Transaction Type)', '交易量(Volume)', '建仓时间(Open Time)', '建仓价格(Open price)', '当前价格(Close price)', '止损(Sl)', '止盈(Tp)', '手续费(Commission)', '利息(Storage)', '盈亏(Profit)'];
          const filterVal = ['order', 'symbol', 'cmd', 'volume', 'openTime', 'openPrice', 'closePrice', 'sl', 'tp', 'commission', 'storage', 'profit'];
          for (let i = 0; i < res.data.content.length; i++) {
            res.data.content[i].openTime = parseTime(res.data.content[i].openTime);
            res.data.content[i].closeTime = parseTime(res.data.content[i].closeTime);
            res.data.content[i].custType = _this.getCustTypeSelf(res.data.content[i]) || '-';
            res.data.content[i].cmd = res.data.content[i].cmd % 2 == 0 ? _this.$t('User.buy') : _this.$t('User.sell');

          }
          let fileName = '未平仓单报表';
          const exportData = formatJson(filterVal, res.data.content);
          export_json_to_excel(tHeader, exportData, fileName);
        });
      },
      getActive(row) {
        if ((row.profit + '').indexOf('-') > -1) {
          return true;
        } else {
          return false;
        }
      },
      getCustTypeSelf(row) {
        if (row.custType == 0) {
          return this.$t('User.reportDir');
        } else if (row.custType == 1) {
          return this.$t('User.reportIndir');
        }
      }
    }

  };
</script>
<style scoped lang="scss">
    .userPartner-report_notCloseTable {
        min-height: 500px;
        .input-box,
        .btn-box {
            margin-bottom: 10px;
        }
    }
</style>
